import React, { createContext, useState, useContext, useEffect } from 'react';
import { getCurrentProcessDashboard, updateDashboard} from '../services/apiProcessDashboards';
import { useNavigate } from 'react-router-dom';
import { useAppContext } from './AppContext';
import { useAuth } from './AuthContext';
import CubeLoader from '../components/CubeLoader';
import { getCurrentDashboard } from '../services/apiDashboards';
import { useWidgets } from './WidgetContext';

const DashboardContext = createContext();
export const useDashboards= () => useContext(DashboardContext);

export const DashboardProvider = ({ space ="telemetry", children }) => {
  const navigate = useNavigate();
  const {addToast} = useAppContext();
  
  const {auth, hasPermission} = useAuth();
  
  const [module, setModule] = useState(space);
  const [dashboard, setDashboard] =  useState();
  const [fetchingDashboard, setFetchingDashboard] =  useState(true);
  const [selectedTab, setSelectedTab] = useState();
  const [selectedDatarange, setSelectedDataRange] = useState(); 

  const refreshCurrentDashboard = () => {
    async function fetchDashboard() {
      const currentDashboard = module === "telemetry" ? 
        await getCurrentDashboard(auth?.token):
        await getCurrentProcessDashboard(auth?.token);
      //setOrganizations(organizationsData);
      return currentDashboard;
    }
    try {
      fetchDashboard().then(response => {
        
        setFetchingDashboard(false);
        setSelectedDataRange(response.dateRange)
        setDashboard(response)
      }).catch(error => 
        {
          if ([419].includes(error.response?.status)){
            addToast("Sesión expirada",1)
            navigate('/logout')
          }
          if ([403].includes(error.response?.status)){
            if (hasPermission('accionistas_transactions', 'transactions', 'read') || hasPermission('accionistas_transactions', 'transactions', 'readAll')) {
              navigate('/accionistas/transacciones');
              return;
            }
            addToast("No autorizado",2)
            navigate('/logout')
          }
          if ([500].includes(error.response?.status)){
            addToast("Ocurrio un error con el servidor, intente nuevamente",3)
          }
        }
      );
    } catch (error) {
      console.log(error)
      fetchDashboard(false);
    }
  }

  const setDataRangeCurrentDashboard = (dataRange) => {
    async function saveDatarange() {
      console.log("guardando", dataRange)
      return await updateDashboard({...dashboard,dateRange: dataRange}, auth?.token)
    }
    try {
      setSelectedDataRange(dataRange)
      saveDatarange().then(response => {
        //setDashboard(response)
      }).catch(error => 
        {
          if ([419].includes(error?.response?.status)){
            addToast("Sesión expirada",1)
            navigate('/logout')
          }
          if ([403].includes(error?.response?.status)){
            addToast("No autorizado",2)
            navigate('/logout')
          }
          if ([500].includes(error?.response?.status)){
            addToast("Ocurrio un error con el servidor, intente nuevamente",3)
          }
        }
      );
    } catch (error) {
      console.log(error)
      
    }
  }
  const setFactorCurrentDashboard = (range) => {
    async function saveRange() {
      console.log("guardando", range)
      return await updateDashboard({...dashboard,factor: range}, auth?.token)
    }
    try {
      saveRange().then(response => {
        setDashboard(response)
      }).catch(error => 
        {
          if ([419].includes(error?.response?.status)){
            addToast("Sesión expirada",1)
            navigate('/logout')
          }
          if ([403].includes(error?.response?.status)){
            addToast("No autorizado",2)
            navigate('/logout')
          }
          if ([500].includes(error?.response?.status)){
            addToast("Ocurrio un error con el servidor, intente nuevamente",3)
          }
        }
      );
    } catch (error) {
      console.log(error)
      
    }
  }

  const handleSelectionTab = (selectedTab) => {
    setSelectedTab(selectedTab);
    //filtrar los cards de ese tab
    //setDashboard({...dashboard});
  }


  useEffect( ()=> {
    refreshCurrentDashboard();
  }, [module])

  return (
    <DashboardContext.Provider value={
      {
        module, setModule,
        dashboard, setDashboard,
        refreshCurrentDashboard,
        setDataRangeCurrentDashboard,
        setFactorCurrentDashboard,
        selectedTab,setSelectedTab,  handleSelectionTab,
        selectedDatarange, setSelectedDataRange
      }}>
      {fetchingDashboard && (
        <div className='w-full h-full flex items-center justify-center'>
          <CubeLoader />
        </div>
      )}
      {!fetchingDashboard &&(
        children
      )}
     
    </DashboardContext.Provider>
  );
};
